const GENERIC_PAUSE_ERROR = 'Unable to pause subscription.'
const GENERIC_RESUME_ERROR = 'Unable to resume subscription.'

function getGenericPauseResumeError (action) {
  return action === 'pause' ? GENERIC_PAUSE_ERROR : GENERIC_RESUME_ERROR
}

/**
 * Returns the first error string from Brooklyn pause/resume API bodies.
 */
export function getFirstPauseResumeErrorMessage (errors) {
  if (!errors || errors.length === 0) {
    return null
  }

  const first = errors[0]
  if (typeof first === 'string') {
    return first
  }

  if (first && typeof first.message === 'string') {
    return first.message
  }

  return String(first)
}

/**
 * Parses nested gatewayResponse data from a Brooklyn pause/resume error message.
 */
export function extractGatewayResponseFromPauseResumeError (errorText) {
  if (!errorText) {
    return null
  }

  const jsonStart = errorText.indexOf('{')
  if (jsonStart === -1) {
    return null
  }

  try {
    const parsed = JSON.parse(errorText.slice(jsonStart))
    const reasons = parsed.reasons || []

    const gatewayResponse = reasons
      .map((reason) => {
        if (!reason || typeof reason.message !== 'string') {
          return null
        }

        try {
          const reasonMessage = JSON.parse(reason.message)
          return reasonMessage.gatewayResponse || null
        } catch {
          return null
        }
      })
      .find(Boolean)

    return gatewayResponse || null
  } catch {
    return null
  }
}

/**
 * Formats pause/resume API failures for display in the admin UI.
 */
export function formatPauseResumeApiError (body, action = 'resume') {
  if (!body || body.success !== false) {
    return null
  }

  const errorText = getFirstPauseResumeErrorMessage(body.errors)

  if (body.errorCode === 'PAYMENT_ERROR') {
    const gatewayResponse = extractGatewayResponseFromPauseResumeError(errorText)
    if (gatewayResponse) {
      return `Payment Error: ${gatewayResponse.message}, Code ${gatewayResponse.code}`
    }

    return 'Payment Error: Unable to process payment.'
  }

  if (errorText) {
    return errorText
  }

  return getGenericPauseResumeError(action)
}
